export default {"src":"/_next/static/media/guide.9e7259c3.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};